import { render, staticRenderFns } from "./que.vue?vue&type=template&id=6a7a1b99&scoped=true&"
import script from "./que.vue?vue&type=script&lang=js&"
export * from "./que.vue?vue&type=script&lang=js&"
import style0 from "./que.vue?vue&type=style&index=0&id=6a7a1b99&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a7a1b99",
  null
  
)

export default component.exports